export default __webpack_public_path__ + "static/media/profile.4241ebb7.jpg";